import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Table, EllipsisDropdown, ControlledPopup, UserAvatarList, STATUS_TYPES, USER_PERMISSIONS, PRODUCT_PERMISSIONS, Notification } from 'dyl-components';
import { Loader, Segment, Header, Dropdown } from 'semantic-ui-react';
import { StringUtils } from 'utils';
import roleActions from 'actions/role';
import rolesActions from 'actions/roles';
import './PermissionsRow.scss';
import { useDispatch } from 'react-redux';
import RestrictedView from 'shared/RestrictedView';
import userActions from 'actions/user';

const PermissionsRow = ({
    permission,
    isDeletingRole,
    user_id
}) => {
    const dispatch = useDispatch();
    const name = (!permission.editable) ? StringUtils.capitalize(permission.name) : permission.name;
    const navigate = useNavigate();
    const showPermission = (permission, type='view') => {
        const id = permission.id
        const paths = {
            view: `/settings/view-permission-profile/${id}`,
            edit: `/settings/edit-permission-profile/${id}`,
            duplicate: `/settings/add-permission-profile`
        }

        navigate(paths[type], { state: {incomingPermission: {type, permission, permid:permission?.id}} });
    }

    const onDelete = (id) => {
        dispatch(userActions.getProductLimits());
        dispatch(roleActions.deleteUserRole(id))
            .then(() => {
                Notification.alert(
                    "Successfully removed permission profile!",
                    STATUS_TYPES.SUCCESS,
                    true
                );
                dispatch(rolesActions.readRoles());
            })
            .catch((error) => {
                if (
                    error.message ===
                    "method delete_role - error :Access role not empty."
                ) {
                    Notification.alert(
                        "Permission Profile has assigned user(s).",
                        STATUS_TYPES.ERROR,
                        true
                    );
                } else {
                    Notification.alert(
                        "Failed to remove Permisssion Profile",
                        STATUS_TYPES.ERROR,
                        true
                    );
                }
            });
    };

    const isAdminUser = Boolean(!permission?.is_administrative_owner_role && !permission?.is_owner_role && !permission?.editable)

    return (
        <Table.Row loading={isDeletingRole}>
            <Table.Cell width={4}>
                <Header
                    as="h3"
                    color="blue"
                    className={"PermissionLink"}
                    onClick={() => {
                        showPermission(
                            permission,
                            permission.editable ? "edit" : "view",
                        );
                    }}
                >
                    {name}
                </Header>
                {permission.description}
            </Table.Cell>
            <Table.Cell>
                <UserAvatarList
                    user_id={user_id}
                    usersList={permission.assignees.map((user) => ({
                        ...user,
                        inactive: !user.active,
                    }))}
                    usersLimit={10}
                />
            </Table.Cell>
            <Table.Cell>
                {!permission?.is_administrative_owner_role && !permission?.is_owner_role && (
                    <EllipsisDropdown>
                            {!isAdminUser && <RestrictedView
                                type="disabled"
                                userPermission={
                                    USER_PERMISSIONS.PERMISSIONS_EDIT
                                }
                            >
                                <Dropdown.Item
                                    icon="pencil"
                                    text="Edit"
                                    onClick={() => {
                                        showPermission(permission, "edit");
                                    }}
                                />
                            </RestrictedView>}
                            <RestrictedView
                                type="disabled"
                                userPermission={
                                    USER_PERMISSIONS.PERMISSIONS_ADD
                                }
                                productPermission={PRODUCT_PERMISSIONS.SETTINGS_PERMISSION_PROFILE}
                            >
                                <Dropdown.Item
                                    icon="copy"
                                    text="Duplicate"
                                    onClick={() => {
                                        showPermission(permission, "duplicate");
                                    }}
                                />
                            </RestrictedView>
                           {!isAdminUser && <RestrictedView
                                type="controlledPopupDisabled"
                                userPermission={
                                    USER_PERMISSIONS.PERMISSIONS_DELETE
                                }
                            >
                                <ControlledPopup
                                    trigger={
                                        <Dropdown.Item
                                            icon="trash"
                                            text="Delete"
                                            disabled={Boolean(permission?.assignees?.length)}
                                        />
                                    }
                                    onConfirm={() => onDelete(permission?.id)}
                                    content={"Delete"}
                                    inverted
                                />
                            </RestrictedView>}
                    </EllipsisDropdown>
                )}
            </Table.Cell>
        </Table.Row>
    );
};

const PermissionsRowContainer = (props) => {
    const { roleBeingDeleted } = useSelector((state) => ({
        roleBeingDeleted: state.role.roleBeingDeleted,
    }));
    const isDeletingRole = roleBeingDeleted === props?.permission?.id;

    if (isDeletingRole) {
        return (
            <Table.Row>
                <Table.Cell colSpan={3}>
                    <Segment basic>
                        <Loader active />
                    </Segment>
                </Table.Cell>
            </Table.Row>
        );
    }

    return (
        <React.Fragment>
            <PermissionsRow isDeletingRole={isDeletingRole} {...props} user_id={props.user_id} />
        </React.Fragment>
    );
};

export default PermissionsRowContainer;
